import { SecureRandom } from 'jsbn';
import { hex2b64 } from './base64';
import { RSAKey } from './rsa';

let publicKey = null;

fetch('/rest/Session/serverPublicKeySpec')
    .then(res => res.json())
    .then(
        (publicKeySpec) => {
            const initSecureRandom = new SecureRandom();
            publicKey = new RSAKey();
            publicKey.setPublic(publicKeySpec.modulusHexString, publicKeySpec.publicExponentHexString);
        },
        (error) => {}
    );

export default {
    encryptWithServerPublicKey: (value) => {
        //Fixes issue with the added prototype method not being added in the RSA code in FireFox
        let initSecureRandom = new SecureRandom();
        let result = publicKey.encrypt(value);
        return hex2b64(result);
    }
}


